var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('b-row',{staticClass:"mt-1"},[_c('b-col',{staticClass:"mt-0 text-centre pl-3",attrs:{"md":"12"}},[_c('div',{},[_c('b-table',{staticClass:"bg-white",attrs:{"striped":"","hover":"","outlined":"","items":_vm.recoveryList,"fields":_vm.recoveryFields,"show-empty":"","sticky-header":""}})],1)])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }